export default __webpack_public_path__ + "static/media/arrow-slide-left.67fbfdd3.svg";